import { render, staticRenderFns } from "./CLP01.vue?vue&type=template&id=5f06a2a2&scoped=true"
import script from "./CLP01.vue?vue&type=script&lang=js"
export * from "./CLP01.vue?vue&type=script&lang=js"
import style0 from "./CLP01.vue?vue&type=style&index=0&id=5f06a2a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f06a2a2",
  null
  
)

export default component.exports